import gql from "graphql-tag";
import { Fragment, TemplateSection } from "../types";
import {
  TemplateQuestionFragment,
  TEMPLATE_QUESTION_FRAGMENT,
} from "./TemplateQuestion";

export const TEMPLATE_SECTION_FRAGMENT = gql`
  fragment TemplateSectionFragment on TemplateSection {
    id
    title
    type
    description
    order
    templateQuestions {
      ...TemplateQuestionFragment
    }
  }

  ${TEMPLATE_QUESTION_FRAGMENT}
`;

export type TemplateSectionFragment = Fragment<
  TemplateSection,
  Pick<TemplateSection, "id" | "title" | "type" | "description" | "order"> & {
    templateQuestions: TemplateQuestionFragment[];
  }
>;
